import { render } from "./Group.vue?vue&type=template&id=cf842c3a&scoped=true"
const script = {}

import "./Group.vue?vue&type=style&index=0&id=cf842c3a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf842c3a"],['__file',"src/js/components/Group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf842c3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf842c3a', __exports__)) {
    api.reload('cf842c3a', __exports__)
  }
  
  module.hot.accept("./Group.vue?vue&type=template&id=cf842c3a&scoped=true", () => {
    api.rerender('cf842c3a', render)
  })

}


export default __exports__